<template>
  <div>
    <p>
      {{
        ft(
          featureName,
          'reportingChannels.physicalMeeting.responseDescription',
          $t,
          {
            organizationTitle: organizationFullName,
            email
          }
        )
      }}
    </p>
    <followup-case-details
      class="mt-4"
      :case-name="caseName"
      :followup-url="followupUrl"
      :password="password"
      :feature-name="featureName"
    />

    <b-row class="my-4">
      <b-alert
        :show="true"
        variant="default"
        class="d-flex align-items-center px-0"
      >
        <i class="bi bi-info-circle-fill text-info mx-3"></i>
        <span class="text-info">
          {{ ft(featureName, 'received.bottomWarning', $t) }}
        </span>
      </b-alert>
    </b-row>
  </div>
</template>
<script>
import FollowupCaseDetails from './FollowupCaseDetails.vue'
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'PhysicalMeetingResponse',
  components: { FollowupCaseDetails },
  extends: LocalizableComponent,
  props: {
    organizationName: {
      type: String,
      required: true
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    caseName: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: null,
      required: false
    },
    locale: {
      type: String,
      default: null,
      required: false
    },
    followupUrl: {
      type: String,
      required: true
    },
    featureName: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped></style>
